import React from 'react';
import {Link} from 'react-router-dom';

const NavbarButton = ({icon, label, to}) => {
  return (
    <Link className="navbar-button-container navbar-button-link" to={to}>
      <i className={icon} />
      <p className="navbar-button-link">{label}</p>
    </Link>
  );
};

export default NavbarButton;
